import { SelectedExternalFile } from "@/lib/external-file-browser";
import { externalFileControllerAddExternalFile } from "@/lib/gen-api";
import { toast } from "sonner";

export const useLibraryExternalFileUploadAction = (props: {
  groupUuid: string | null;
  kitUuid: string | null;
}) => {
  const upload = async (params: {
    groupUuid?: string | null;
    kitUuid: string;
    file: SelectedExternalFile;
  }) => {
    const groupUuid = props.groupUuid || params.groupUuid;
    const kitUuid = props.kitUuid || params.kitUuid;

    if (!groupUuid || !kitUuid) {
      throw new Error("Group and kit UUID are required");
    }

    const file = params.file;

    const response = await externalFileControllerAddExternalFile({
      body: {
        connectionUuid: file.connectionUuid,
        externalId: file.externalId,
        driveId: file.driveId,
        name: file.name,
        isKnowledge: false,
        isLibrary: true,
        groupUuid: groupUuid,
        kitUuid: kitUuid,
      },
    });

    const data = response.data;

    if (!data) {
      toast.error("Failed to upload external file");
      throw new Error("Failed to upload external file");
    }

    return response.data;
  };

  return {
    upload,
  };
};
